import { render, staticRenderFns } from "./PDFDetail.vue?vue&type=template&id=67d47b96&scoped=true"
import script from "./PDFDetail.vue?vue&type=script&lang=js"
export * from "./PDFDetail.vue?vue&type=script&lang=js"
import style0 from "./PDFDetail.vue?vue&type=style&index=0&id=67d47b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d47b96",
  null
  
)

export default component.exports